<template>
	<div class="border">
		<div @click.prevent="copyLinkToClipboard"><LinkNotationSvg /></div>
	</div>
</template>

<script>
import LinkNotationSvg from './assets/LinkNotationSvg';

export default {
	name: 'LinkCopy',
	components: {
		LinkNotationSvg,
	},
	props: {
		src: { type: String },
		hideText: { type: Boolean, default: false },
		preventOpenLink: { type: Boolean, default: false },
	},
	methods: {
		openLink() {
			if (this.preventOpenLink) {
				return;
			}
			window.open(this.src, '_blank');
		},
		copyLinkToClipboard() {
			navigator.clipboard.writeText(this.src);
			this.$toast.success('Copied link');
		},
	},
};
</script>

<style scoped lang="scss">
.border {
	height: 35px !important;
	border: 1px solid #fff;
	transition: 0.3s;
	&:hover {
		cursor: pointer;
	}
	filter: brightness(90%);
	opacity: 0.8;
	align-self: center;
	padding: 3px;
	padding-top: 7px !important;
	border-top-right-radius: 6px;
	border-bottom-right-radius: 6px;
}
</style>
